import { useContext } from "react";
import { OBJECT_TYPE } from "common/constants";
import { Loading } from "../ActivityFeed/__styles__/Activity";
import InfoPanelActivityFeed from "../ActivityFeed/InfoPanelActivityFeed";
import Icon, { ICON_COLORS, Icons } from "../Common/Icons";
import { AddressPanelTabProps } from ".";
import { Section, Wrapper } from "./__styles__/AddressPanel";
import { AddressPanelContext } from "./AddressPanelContext";
import MissingProperty from "./MissingProperty";

const Activity = ({ address, latitude, longitude }: AddressPanelTabProps) => {
  const { property, loadingProperty } = useContext(AddressPanelContext);
  const content =
    property ?
      <InfoPanelActivityFeed
        objectType={OBJECT_TYPE.PROPERTY}
        object={property}
      />
    : loadingProperty ?
      <Loading>
        <Icon icon={Icons.LOADING} color={ICON_COLORS.LIGHT_GREY} />
      </Loading>
    : <MissingProperty
        title="No activity tracking available"
        address={address}
        latitude={latitude}
        longitude={longitude}
      />;

  return (
    <Wrapper>
      <Section>{content}</Section>
    </Wrapper>
  );
};

export default Activity;
